import WebComponent from '../webComponents/WebComponent';
import classNames from '../lib/classNames';
// neimportuje se $ protože, chceme kompatibilitu i na webech bez jQuery k jquery se pak musí přistupovat přes window.$, aby se nehádalo popřípadě s jiným jquery na stránce

const FRAGMENTS = {
  RADIO_WITH_EXTENDED_TEXT_INPUT: '[data-fragment="radioWithExtendedTextInput"]',
};

// TODO funguje jen pro jeden extended text input v celém RadioSelectu
class RadioSelect extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExtendedTextInputVisible: false,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  didMount() {
    const {
      selectedClassName
    } = this.props;
    this.on('change', 'input', this.handleChange);
    const fragment = this.elements.RADIO_WITH_EXTENDED_TEXT_INPUT;
    const classList = fragment ? [...fragment.classList] : [];
    const isExtendedTextInputVisible = classList.includes(selectedClassName);
    this.setState({
      isExtendedTextInputVisible,
    });
    // this.on('change', FRAGMENTS.INPUT, this.handleInputEventChange);
  }
  handleChange = (e) => {
    const radioWithInput = e.target.closest(FRAGMENTS.RADIO_WITH_EXTENDED_TEXT_INPUT);
    const isExtendedTextInputVisible = radioWithInput != null;
    this.setState({
      isExtendedTextInputVisible
    });
    // dispatch change event for eventual partialUpdate
    if(window.$) {
      window.$(e.target).trigger('requestValidation');
    }
    e.stopPropagation();
    this.dispatchChangeEvent();
  }
  update(prevProps, prevState, inDocument) {
    const {
      selectedClassName
    } = this.props;
    const {
      isExtendedTextInputVisible
    } = this.state;
    if (this.elements.RADIO_WITH_EXTENDED_TEXT_INPUT) {
      classNames(this.elements.RADIO_WITH_EXTENDED_TEXT_INPUT, {
        [selectedClassName]: isExtendedTextInputVisible
      });
    }
    if(isExtendedTextInputVisible) {
      this.elements.RADIO_WITH_EXTENDED_TEXT_INPUT.querySelector('[type="text"]').focus();
    }
  }
}

RadioSelect.fragments = FRAGMENTS;
RadioSelect.defaultProps = {
  selectedClassName: 'customRadio__isSelected',
};

export default RadioSelect;




// WEBPACK FOOTER //
// ./node_modules/@fg/fg-frontend/src/components/RadioSelect.js